import { Link } from 'react-router-dom';

const quickCreateRedirect = encodeURIComponent('/app-summary');

export default function HeroSection() {
  return (
    <section className="min-h-screen py-16 sm:py-24 bg-zapt-navy relative overflow-hidden flex items-center">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
        style={{ backgroundImage: 'url(https://zapt-cdn.com/dc408fb4-e206-4be6-8677-dfc0f17d99f7/background_image.jpg)' }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-zapt-navy/80 via-zapt-navy/75 to-zapt-navy/85" />
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-zapt-purple via-zapt-yellow to-zapt-purple" />
      <div className="absolute top-1/4 -left-48 w-96 h-96 bg-zapt-purple rounded-full blur-3xl opacity-20" />
      <div className="absolute bottom-1/4 -right-48 w-96 h-96 bg-zapt-purple rounded-full blur-3xl opacity-15" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full text-center">

        {/* Eyebrow */}
        <p className="text-zapt-yellow/80 text-sm sm:text-base font-semibold tracking-widest uppercase mb-6">
          Software for your business
        </p>

        {/* Headline */}
        <h1 className="font-black text-white tracking-tight leading-[1.05] mb-4">
          <span className="block text-4xl sm:text-6xl md:text-7xl">Pre-built apps</span>
          <span className="block text-4xl sm:text-6xl md:text-7xl">to use today.</span>
          <span className="block text-3xl sm:text-5xl md:text-6xl text-zapt-yellow mt-2">Custom solutions built to order.</span>
        </h1>

        {/* Divider */}
        <div className="w-16 h-1 bg-zapt-yellow mx-auto mt-8 mb-10 rounded-full opacity-60" />

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#apps-weve-built"
            className="w-full sm:w-auto inline-flex items-center justify-center bg-zapt-yellow text-zapt-navy px-8 py-4 rounded-xl font-bold hover:bg-zapt-yellow/90 transition-all duration-200 text-lg shadow-xl shadow-zapt-yellow/20 hover:shadow-zapt-yellow/40 hover:scale-105 group"
          >
            Browse our apps
            <svg className="w-5 h-5 ml-2 transition-transform group-hover:translate-y-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </a>
          <Link
            to={`/authenticate?redirect=${quickCreateRedirect}`}
            className="w-full sm:w-auto inline-flex items-center justify-center bg-white/10 text-white border border-white/20 px-8 py-4 rounded-xl font-bold hover:bg-white/20 transition-all duration-200 text-lg"
          >
            Describe what you need →
          </Link>
        </div>
      </div>
    </section>
  );
}
